import { useQuery } from '@tanstack/react-query'
import { api } from '@/api/client'

// Uses admin-design theme tokens (bg-card, text-muted-foreground,
// border-border, ...) so dark mode flips automatically.
export default function Dashboard() {
  const me = useQuery({ queryKey: ['me'], queryFn: api.me })
  const stats = useQuery({ queryKey: ['stats'], queryFn: api.stats, refetchInterval: 10000 })
  const version = useQuery({ queryKey: ['version'], queryFn: api.version })
  const pool = useQuery({ queryKey: ['pool'], queryFn: api.poolStats, refetchInterval: 3000 })

  return (
    <div className="space-y-4">
      <section className="border border-border rounded-lg p-4 bg-card text-card-foreground">
        <h2 className="text-sm font-semibold text-muted-foreground mb-2">Signed in as</h2>
        <p className="text-lg">{me.data?.email ?? '…'}</p>
        <p className="text-sm text-muted-foreground">{me.data?.name}</p>
      </section>

      <section className="border border-border rounded-lg p-4 bg-card text-card-foreground">
        <h2 className="text-sm font-semibold text-muted-foreground mb-2">Stats</h2>
        <div className="flex gap-6 text-sm">
          <div>
            Users <b>{stats.data?.users ?? 0}</b>
          </div>
          <div>
            Active sessions <b>{stats.data?.active_sessions ?? 0}</b>
          </div>
        </div>
      </section>

      <section className="border border-border rounded-lg p-4 bg-card text-card-foreground">
        <h2 className="text-sm font-semibold text-muted-foreground mb-2">Browser Pool</h2>
        <div className="flex gap-6 text-sm">
          <div>
            In-flight <b>{pool.data?.inflight ?? 0}</b>
          </div>
          <div>
            Served since last restart <b>{pool.data?.served_total ?? 0}</b>
          </div>
        </div>
      </section>

      <section className="border border-border rounded-lg p-4 bg-card text-card-foreground">
        <h2 className="text-sm font-semibold text-muted-foreground mb-2">Build</h2>
        <p className="text-xs text-muted-foreground">
          commit: <code>{version.data?.commit ?? 'dev'}</code> · built_at:{' '}
          <code>{version.data?.built_at ?? 'unknown'}</code>
        </p>
      </section>
    </div>
  )
}
